import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { Modal } from 'antd';
import './PricesRemark.scss';

class PricesRemark extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }
  showModal = (prices) => {
    this.setState({
      prices: prices,
      visible: true,
    });
  };
  hideModal = () => {
    this.setState({
      visible: false,
    });
  };
  render() {
    const { visible, prices } = this.state;
    return (
      <span>
        <Modal
          open={visible}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title="单价规则说明"
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="500px"
          onCancel={this.hideModal}
        >
          <div className="price-remark-modal">
            <p>
              技能服务价格与类别<label>已完成的接单流水</label>相关哦。
            </p>
            <p>每天可修改20次服务单价。</p>
            <table>
              <tbody>
                <tr>
                  <th>价格阶梯</th>
                  <th>单价</th>
                  <th>已完成的接单流水</th>
                </tr>
                {prices &&
                  prices.map((item, index) => {
                    return (
                      <tr key={`k-${index}`}>
                        <td>{index + 1}</td>
                        <td>￥{item.price}</td>
                        <td>{item.orderNum}元</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <p>
              说明：平台会根据市场与供需调整技能单价与订单总金额，调整后将统一更新全平台大神单价，届时将前提发出公告。最终解释权归平台所有。
            </p>
          </div>
        </Modal>
      </span>
    );
  }
}

export default withRouter(PricesRemark, { withRef: true });
